(function() {
    var GBS_HOST = "https://books.google.com/";
    for (var k, aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
            if (c.get || c.set) throw new TypeError("ES3 does not support getters and setters.");
            a != Array.prototype && a != Object.prototype && (a[b] = c.value)
        }, l = "undefined" != typeof window && window === this ? this : "undefined" != typeof global && null != global ? global : this, ba = ["String", "prototype", "repeat"], ca = 0; ca < ba.length - 1; ca++) {
        var da = ba[ca];
        da in l || (l[da] = {});
        l = l[da]
    }
    var ea = ba[ba.length - 1],
        fa = l[ea],
        ha = fa ? fa : function(a) {
            var b;
            if (null == this) throw new TypeError("The 'this' value for String.prototype.repeat must not be null or undefined");
            b = this + "";
            if (0 > a || 1342177279 < a) throw new RangeError("Invalid count value");
            a |= 0;
            for (var c = ""; a;)
                if (a & 1 && (c += b), a >>>= 1) b += b;
            return c
        };
    ha != fa && null != ha && aa(l, ea, {
        configurable: !0,
        writable: !0,
        value: ha
    });
    var n = this;

    function p(a) {
        return void 0 !== a
    }

    function q() {}

    function ia(a) {
        var b = typeof a;
        if ("object" == b)
            if (a) {
                if (a instanceof Array) return "array";
                if (a instanceof Object) return b;
                var c = Object.prototype.toString.call(a);
                if ("[object Window]" == c) return "object";
                if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";
                if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function"
            } else return "null";
        else if ("function" == b && "undefined" == typeof a.call) return "object";
        return b
    }

    function r(a) {
        return "array" == ia(a)
    }

    function ja(a) {
        var b = ia(a);
        return "array" == b || "object" == b && "number" == typeof a.length
    }

    function t(a) {
        return "string" == typeof a
    }

    function u(a) {
        return "function" == ia(a)
    }

    function ka(a) {
        var b = typeof a;
        return "object" == b && null != a || "function" == b
    }

    function la(a, b, c) {
        return a.call.apply(a.bind, arguments)
    }

    function ma(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var c = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(c, d);
                return a.apply(b, c)
            }
        }
        return function() {
            return a.apply(b, arguments)
        }
    }

    function v(a, b, c) {
        v = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? la : ma;
        return v.apply(null, arguments)
    }

    function na(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var b = c.slice();
            b.push.apply(b, arguments);
            return a.apply(this, b)
        }
    }
    var oa = Date.now || function() {
        return +new Date
    };

    function x(a, b) {
        var c = a.split("."),
            d = n;
        c[0] in d || !d.execScript || d.execScript("var " + c[0]);
        for (var e; c.length && (e = c.shift());) !c.length && p(b) ? d[e] = b : d[e] ? d = d[e] : d = d[e] = {}
    }

    function y(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.ta = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
        a.ya = function(a, c, f) {
            for (var d = Array(arguments.length - 2), e = 2; e < arguments.length; e++) d[e - 2] = arguments[e];
            return b.prototype[c].apply(a, d)
        }
    };

    function pa(a, b, c) {
        this.o = c;
        this.i = a;
        this.j = b;
        this.g = 0;
        this.b = null
    }
    pa.prototype.get = function() {
        var a;
        0 < this.g ? (this.g--, a = this.b, this.b = a.next, a.next = null) : a = this.i();
        return a
    };

    function qa(a, b) {
        a.j(b);
        a.g < a.o && (a.g++, b.next = a.b, a.b = b)
    };

    function z(a) {
        if (Error.captureStackTrace) Error.captureStackTrace(this, z);
        else {
            var b = Error().stack;
            b && (this.stack = b)
        }
        a && (this.message = String(a))
    }
    y(z, Error);
    z.prototype.name = "CustomError";

    function ra() {}

    function sa(a, b, c) {
        if (null == b) c.push("null");
        else {
            if ("object" == typeof b) {
                if (r(b)) {
                    var d = b;
                    b = d.length;
                    c.push("[");
                    for (var e = "", f = 0; f < b; f++) c.push(e), sa(a, d[f], c), e = ",";
                    c.push("]");
                    return
                }
                if (b instanceof String || b instanceof Number || b instanceof Boolean) b = b.valueOf();
                else {
                    c.push("{");
                    e = "";
                    for (d in b) Object.prototype.hasOwnProperty.call(b, d) && (f = b[d], "function" != typeof f && (c.push(e), ta(d, c), c.push(":"), sa(a, f, c), e = ","));
                    c.push("}");
                    return
                }
            }
            switch (typeof b) {
                case "string":
                    ta(b, c);
                    break;
                case "number":
                    c.push(isFinite(b) &&
                        !isNaN(b) ? String(b) : "null");
                    break;
                case "boolean":
                    c.push(String(b));
                    break;
                case "function":
                    c.push("null");
                    break;
                default:
                    throw Error("Unknown type: " + typeof b);
            }
        }
    }
    var ua = {
            '"': '\\"',
            "\\": "\\\\",
            "/": "\\/",
            "\b": "\\b",
            "\f": "\\f",
            "\n": "\\n",
            "\r": "\\r",
            "\t": "\\t",
            "\x0B": "\\u000b"
        },
        va = /\uffff/.test("\uffff") ? /[\\\"\x00-\x1f\x7f-\uffff]/g : /[\\\"\x00-\x1f\x7f-\xff]/g;

    function ta(a, b) {
        b.push('"', a.replace(va, function(a) {
            var b = ua[a];
            b || (b = "\\u" + (a.charCodeAt(0) | 65536).toString(16).substr(1), ua[a] = b);
            return b
        }), '"')
    };

    function A(a, b) {
        this.width = a;
        this.height = b
    }
    A.prototype.ceil = function() {
        this.width = Math.ceil(this.width);
        this.height = Math.ceil(this.height);
        return this
    };
    A.prototype.floor = function() {
        this.width = Math.floor(this.width);
        this.height = Math.floor(this.height);
        return this
    };
    A.prototype.round = function() {
        this.width = Math.round(this.width);
        this.height = Math.round(this.height);
        return this
    };

    function wa(a, b) {
        for (var c in a) b.call(void 0, a[c], c, a)
    }
    var xa = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");

    function ya(a, b) {
        for (var c, d, e = 1; e < arguments.length; e++) {
            d = arguments[e];
            for (c in d) a[c] = d[c];
            for (var f = 0; f < xa.length; f++) c = xa[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c])
        }
    };

    function za(a) {
        a.prototype.then = a.prototype.then;
        a.prototype.$goog_Thenable = !0
    }

    function Aa(a) {
        if (!a) return !1;
        try {
            return !!a.$goog_Thenable
        } catch (b) {
            return !1
        }
    };

    function Ba(a) {
        Ba[" "](a);
        return a
    }
    Ba[" "] = q;

    function Ca(a, b) {
        var c = Da;
        return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a)
    };

    function Ea(a, b) {
        for (var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;) d += c.shift() + e.shift();
        return d + c.join("%s")
    }
    var Fa = String.prototype.trim ? function(a) {
        return a.trim()
    } : function(a) {
        return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g, "")
    };

    function Ga(a) {
        if (!Ha.test(a)) return a; - 1 != a.indexOf("&") && (a = a.replace(Ia, "&amp;")); - 1 != a.indexOf("<") && (a = a.replace(Ja, "&lt;")); - 1 != a.indexOf(">") && (a = a.replace(Ka, "&gt;")); - 1 != a.indexOf('"') && (a = a.replace(La, "&quot;")); - 1 != a.indexOf("'") && (a = a.replace(Ma, "&#39;")); - 1 != a.indexOf("\x00") && (a = a.replace(Na, "&#0;"));
        return a
    }
    var Ia = /&/g,
        Ja = /</g,
        Ka = />/g,
        La = /"/g,
        Ma = /'/g,
        Na = /\x00/g,
        Ha = /[\x00&<>"']/;

    function Oa(a, b) {
        return a < b ? -1 : a > b ? 1 : 0
    }

    function Pa(a) {
        return String(a).replace(/\-([a-z])/g, function(a, c) {
            return c.toUpperCase()
        })
    }

    function Qa(a) {
        var b = t(void 0) ? "undefined".replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08") : "\\s";
        return a.replace(new RegExp("(^" + (b ? "|[" + b + "]+" : "") + ")([a-z])", "g"), function(a, b, e) {
            return b + e.toUpperCase()
        })
    };

    function Ra() {
        this.j = this.j;
        this.V = this.V
    }
    Ra.prototype.j = !1;
    var B = "closure_listenable_" + (1E6 * Math.random() | 0),
        Sa = 0;
    var C;
    a: {
        var Ta = n.navigator;
        if (Ta) {
            var Ua = Ta.userAgent;
            if (Ua) {
                C = Ua;
                break a
            }
        }
        C = ""
    }

    function D(a) {
        return -1 != C.indexOf(a)
    };
    var Va = Array.prototype.indexOf ? function(a, b, c) {
            return Array.prototype.indexOf.call(a, b, c)
        } : function(a, b, c) {
            c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;
            if (t(a)) return t(b) && 1 == b.length ? a.indexOf(b, c) : -1;
            for (; c < a.length; c++)
                if (c in a && a[c] === b) return c;
            return -1
        },
        Wa = Array.prototype.forEach ? function(a, b, c) {
            Array.prototype.forEach.call(a, b, c)
        } : function(a, b, c) {
            for (var d = a.length, e = t(a) ? a.split("") : a, f = 0; f < d; f++) f in e && b.call(c, e[f], f, a)
        },
        Xa = Array.prototype.some ? function(a, b, c) {
            return Array.prototype.some.call(a,
                b, c)
        } : function(a, b, c) {
            for (var d = a.length, e = t(a) ? a.split("") : a, f = 0; f < d; f++)
                if (f in e && b.call(c, e[f], f, a)) return !0;
            return !1
        };

    function Ya(a) {
        return Array.prototype.concat.apply(Array.prototype, arguments)
    }

    function Za(a) {
        var b = a.length;
        if (0 < b) {
            for (var c = Array(b), d = 0; d < b; d++) c[d] = a[d];
            return c
        }
        return []
    };

    function $a() {
        this.g = this.b = null
    }
    var bb = new pa(function() {
        return new ab
    }, function(a) {
        a.reset()
    }, 100);
    $a.prototype.remove = function() {
        var a = null;
        this.b && (a = this.b, this.b = this.b.next, this.b || (this.g = null), a.next = null);
        return a
    };

    function ab() {
        this.next = this.g = this.b = null
    }
    ab.prototype.set = function(a, b) {
        this.b = a;
        this.g = b;
        this.next = null
    };
    ab.prototype.reset = function() {
        this.next = this.g = this.b = null
    };

    function E(a, b) {
        this.type = a;
        this.b = this.g = b
    }
    E.prototype.i = function() {};

    function cb(a, b, c, d, e) {
        this.listener = a;
        this.b = null;
        this.src = b;
        this.type = c;
        this.$ = !!d;
        this.ha = e;
        ++Sa;
        this.T = this.W = !1
    }

    function db(a) {
        a.T = !0;
        a.listener = null;
        a.b = null;
        a.src = null;
        a.ha = null
    };
    var eb = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;

    function fb(a, b) {
        if (a)
            for (var c = a.split("&"), d = 0; d < c.length; d++) {
                var e = c[d].indexOf("="),
                    f, g = null;
                0 <= e ? (f = c[d].substring(0, e), g = c[d].substring(e + 1)) : f = c[d];
                b(f, g ? decodeURIComponent(g.replace(/\+/g, " ")) : "")
            }
    };

    function gb(a) {
        this.src = a;
        this.b = {};
        this.g = 0
    }

    function hb(a, b, c, d, e, f) {
        var g = b.toString();
        b = a.b[g];
        b || (b = a.b[g] = [], a.g++);
        var h = ib(b, c, e, f); - 1 < h ? (a = b[h], d || (a.W = !1)) : (a = new cb(c, a.src, g, !!e, f), a.W = d, b.push(a));
        return a
    }
    gb.prototype.remove = function(a, b, c, d) {
        a = a.toString();
        if (!(a in this.b)) return !1;
        var e = this.b[a];
        b = ib(e, b, c, d);
        return -1 < b ? (db(e[b]), Array.prototype.splice.call(e, b, 1), 0 == e.length && (delete this.b[a], this.g--), !0) : !1
    };

    function jb(a, b) {
        var c = b.type;
        if (c in a.b) {
            var d = a.b[c],
                e = Va(d, b),
                f;
            (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
            f && (db(b), 0 == a.b[c].length && (delete a.b[c], a.g--))
        }
    }

    function ib(a, b, c, d) {
        for (var e = 0; e < a.length; ++e) {
            var f = a[e];
            if (!f.T && f.listener == b && f.$ == !!c && f.ha == d) return e
        }
        return -1
    };

    function kb() {
        this.b = "";
        this.g = lb
    }
    var lb = {};

    function mb(a) {
        n.setTimeout(function() {
            throw a;
        }, 0)
    }
    var nb;

    function ob() {
        var a = n.MessageChannel;
        "undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && !D("Presto") && (a = function() {
            var a = document.createElement("IFRAME");
            a.style.display = "none";
            a.src = "";
            document.documentElement.appendChild(a);
            var b = a.contentWindow,
                a = b.document;
            a.open();
            a.write("");
            a.close();
            var c = "callImmediate" + Math.random(),
                d = "file:" == b.location.protocol ? "*" : b.location.protocol + "//" + b.location.host,
                a = v(function(a) {
                    if (("*" == d || a.origin == d) && a.data ==
                        c) this.port1.onmessage()
                }, this);
            b.addEventListener("message", a, !1);
            this.port1 = {};
            this.port2 = {
                postMessage: function() {
                    b.postMessage(c, d)
                }
            }
        });
        if ("undefined" !== typeof a && !D("Trident") && !D("MSIE")) {
            var b = new a,
                c = {},
                d = c;
            b.port1.onmessage = function() {
                if (p(c.next)) {
                    c = c.next;
                    var a = c.cb;
                    c.cb = null;
                    a()
                }
            };
            return function(a) {
                d.next = {
                    cb: a
                };
                d = d.next;
                b.port2.postMessage(0)
            }
        }
        return "undefined" !== typeof document && "onreadystatechange" in document.createElement("SCRIPT") ? function(a) {
            var b = document.createElement("SCRIPT");
            b.onreadystatechange = function() {
                b.onreadystatechange = null;
                b.parentNode.removeChild(b);
                b = null;
                a();
                a = null
            };
            document.documentElement.appendChild(b)
        } : function(a) {
            n.setTimeout(a, 0)
        }
    };
    var pb = "StopIteration" in n ? n.StopIteration : {
        message: "StopIteration",
        stack: ""
    };

    function qb() {}
    qb.prototype.next = function() {
        throw pb;
    };
    qb.prototype.va = function() {
        return this
    };

    function F(a, b) {
        this.g = p(a) ? a : 0;
        this.b = p(b) ? b : 0
    }
    F.prototype.ceil = function() {
        this.g = Math.ceil(this.g);
        this.b = Math.ceil(this.b);
        return this
    };
    F.prototype.floor = function() {
        this.g = Math.floor(this.g);
        this.b = Math.floor(this.b);
        return this
    };
    F.prototype.round = function() {
        this.g = Math.round(this.g);
        this.b = Math.round(this.b);
        return this
    };
    var rb = D("Opera"),
        G = D("Trident") || D("MSIE"),
        sb = D("Edge"),
        H = D("Gecko") && !(-1 != C.toLowerCase().indexOf("webkit") && !D("Edge")) && !(D("Trident") || D("MSIE")) && !D("Edge"),
        I = -1 != C.toLowerCase().indexOf("webkit") && !D("Edge");

    function tb() {
        var a = n.document;
        return a ? a.documentMode : void 0
    }
    var ub;
    a: {
        var vb = "",
            wb = function() {
                var a = C;
                if (H) return /rv\:([^\);]+)(\)|;)/.exec(a);
                if (sb) return /Edge\/([\d\.]+)/.exec(a);
                if (G) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
                if (I) return /WebKit\/(\S+)/.exec(a);
                if (rb) return /(?:Version)[ \/]?(\S+)/.exec(a)
            }();wb && (vb = wb ? wb[1] : "");
        if (G) {
            var xb = tb();
            if (null != xb && xb > parseFloat(vb)) {
                ub = String(xb);
                break a
            }
        }
        ub = vb
    }
    var yb = ub,
        Da = {};

    function J(a) {
        return Ca(a, function() {
            for (var b = 0, c = Fa(String(yb)).split("."), d = Fa(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++) {
                var g = c[f] || "",
                    h = d[f] || "";
                do {
                    g = /(\d*)(\D*)(.*)/.exec(g) || ["", "", "", ""];
                    h = /(\d*)(\D*)(.*)/.exec(h) || ["", "", "", ""];
                    if (0 == g[0].length && 0 == h[0].length) break;
                    b = Oa(0 == g[1].length ? 0 : parseInt(g[1], 10), 0 == h[1].length ? 0 : parseInt(h[1], 10)) || Oa(0 == g[2].length, 0 == h[2].length) || Oa(g[2], h[2]);
                    g = g[3];
                    h = h[3]
                } while (0 == b)
            }
            return 0 <= b
        })
    }
    var zb;
    var Ab = n.document;
    zb = Ab && G ? tb() || ("CSS1Compat" == Ab.compatMode ? parseInt(yb, 10) : 5) : void 0;

    function Bb(a, b) {
        Cb || Db();
        Eb || (Cb(), Eb = !0);
        var c = Fb,
            d = bb.get();
        d.set(a, b);
        c.g ? c.g.next = d : c.b = d;
        c.g = d
    }
    var Cb;

    function Db() {
        var a = n.Promise;
        if (-1 != String(a).indexOf("[native code]")) {
            var b = a.resolve(void 0);
            Cb = function() {
                b.then(Gb)
            }
        } else Cb = function() {
            var a = Gb;
            !u(n.setImmediate) || n.Window && n.Window.prototype && !D("Edge") && n.Window.prototype.setImmediate == n.setImmediate ? (nb || (nb = ob()), nb(a)) : n.setImmediate(a)
        }
    }
    var Eb = !1,
        Fb = new $a;

    function Gb() {
        for (var a; a = Fb.remove();) {
            try {
                a.b.call(a.g)
            } catch (b) {
                mb(b)
            }
            qa(bb, a)
        }
        Eb = !1
    };
    var Hb = !G || 9 <= Number(zb);
    !H && !G || G && 9 <= Number(zb) || H && J("1.9.1");
    G && J("9");
    var Ib = !G || 9 <= Number(zb),
        Jb = G && !J("9");
    !I || J("528");
    H && J("1.9b") || G && J("8") || rb && J("9.5") || I && J("528");
    H && !J("8") || G && J("9");

    function Kb(a, b) {
        this.g = {};
        this.b = [];
        this.j = this.i = 0;
        var c = arguments.length;
        if (1 < c) {
            if (c % 2) throw Error("Uneven number of arguments");
            for (var d = 0; d < c; d += 2) this.set(arguments[d], arguments[d + 1])
        } else if (a) {
            var e;
            if (a instanceof Kb) e = a.U(), d = a.S();
            else {
                var c = [],
                    f = 0;
                for (e in a) c[f++] = e;
                e = c;
                c = [];
                f = 0;
                for (d in a) c[f++] = a[d];
                d = c
            }
            for (c = 0; c < e.length; c++) this.set(e[c], d[c])
        }
    }
    k = Kb.prototype;
    k.S = function() {
        Lb(this);
        for (var a = [], b = 0; b < this.b.length; b++) a.push(this.g[this.b[b]]);
        return a
    };
    k.U = function() {
        Lb(this);
        return this.b.concat()
    };
    k.clear = function() {
        this.g = {};
        this.j = this.i = this.b.length = 0
    };
    k.remove = function(a) {
        return K(this.g, a) ? (delete this.g[a], this.i--, this.j++, this.b.length > 2 * this.i && Lb(this), !0) : !1
    };

    function Lb(a) {
        if (a.i != a.b.length) {
            for (var b = 0, c = 0; b < a.b.length;) {
                var d = a.b[b];
                K(a.g, d) && (a.b[c++] = d);
                b++
            }
            a.b.length = c
        }
        if (a.i != a.b.length) {
            for (var e = {}, c = b = 0; b < a.b.length;) d = a.b[b], K(e, d) || (a.b[c++] = d, e[d] = 1), b++;
            a.b.length = c
        }
    }
    k.get = function(a, b) {
        return K(this.g, a) ? this.g[a] : b
    };
    k.set = function(a, b) {
        K(this.g, a) || (this.i++, this.b.push(a), this.j++);
        this.g[a] = b
    };
    k.forEach = function(a, b) {
        for (var c = this.U(), d = 0; d < c.length; d++) {
            var e = c[d],
                f = this.get(e);
            a.call(b, f, e, this)
        }
    };
    k.va = function(a) {
        Lb(this);
        var b = 0,
            c = this.j,
            d = this,
            e = new qb;
        e.next = function() {
            if (c != d.j) throw Error("The map has changed since the iterator was created");
            if (b >= d.b.length) throw pb;
            var e = d.b[b++];
            return a ? e : d.g[e]
        };
        return e
    };

    function K(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b)
    };

    function Mb(a, b) {
        wa(b, function(b, d) {
            "style" == d ? a.style.cssText = b : "class" == d ? a.className = b : "for" == d ? a.htmlFor = b : Nb.hasOwnProperty(d) ? a.setAttribute(Nb[d], b) : 0 == d.lastIndexOf("aria-", 0) || 0 == d.lastIndexOf("data-", 0) ? a.setAttribute(d, b) : a[d] = b
        })
    }
    var Nb = {
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        colspan: "colSpan",
        frameborder: "frameBorder",
        height: "height",
        maxlength: "maxLength",
        nonce: "nonce",
        role: "role",
        rowspan: "rowSpan",
        type: "type",
        usemap: "useMap",
        valign: "vAlign",
        width: "width"
    };

    function Ob() {
        var a = window.document,
            a = "CSS1Compat" == a.compatMode ? a.documentElement : a.body;
        return new A(a.clientWidth, a.clientHeight)
    }

    function Pb() {
        var a = document,
            b = a.scrollingElement ? a.scrollingElement : I || "CSS1Compat" != a.compatMode ? a.body || a.documentElement : a.documentElement,
            a = a.parentWindow || a.defaultView;
        return G && J("10") && a.pageYOffset != b.scrollTop ? new F(b.scrollLeft, b.scrollTop) : new F(a.pageXOffset || b.scrollLeft, a.pageYOffset || b.scrollTop)
    }

    function Qb(a, b, c) {
        var d = arguments,
            e = document,
            f = String(d[0]),
            g = d[1];
        if (!Hb && g && (g.name || g.type)) {
            f = ["<", f];
            g.name && f.push(' name="', Ga(g.name), '"');
            if (g.type) {
                f.push(' type="', Ga(g.type), '"');
                var h = {};
                ya(h, g);
                delete h.type;
                g = h
            }
            f.push(">");
            f = f.join("")
        }
        f = e.createElement(f);
        g && (t(g) ? f.className = g : r(g) ? f.className = g.join(" ") : Mb(f, g));
        2 < d.length && Rb(e, f, d);
        return f
    }

    function Rb(a, b, c) {
        function d(c) {
            c && b.appendChild(t(c) ? a.createTextNode(c) : c)
        }
        for (var e = 2; e < c.length; e++) {
            var f = c[e];
            !ja(f) || ka(f) && 0 < f.nodeType ? d(f) : Wa(Sb(f) ? Za(f) : f, d)
        }
    }

    function L(a) {
        return document.createElement(String(a))
    }

    function Tb(a) {
        return a && a.parentNode ? a.parentNode.removeChild(a) : null
    }

    function Sb(a) {
        if (a && "number" == typeof a.length) {
            if (ka(a)) return "function" == typeof a.item || "string" == typeof a.item;
            if (u(a)) return "function" == typeof a.item
        }
        return !1
    };

    function M(a, b) {
        E.call(this, a ? a.type : "");
        this.j = this.b = this.g = null;
        a && this.init(a, b)
    }
    y(M, E);
    M.prototype.init = function(a, b) {
        this.type = a.type;
        this.g = a.target || a.srcElement;
        this.b = b;
        var c = a.relatedTarget;
        if (c && H) try {
            Ba(c.nodeName)
        } catch (d) {}
        this.j = a;
        a.defaultPrevented && this.i()
    };
    M.prototype.i = function() {
        M.ta.i.call(this);
        var a = this.j;
        if (a.preventDefault) a.preventDefault();
        else if (a.returnValue = !1, Jb) try {
            if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1
        } catch (b) {}
    };

    function N(a, b) {
        this.b = 0;
        this.u = void 0;
        this.j = this.g = this.i = null;
        this.o = this.s = !1;
        if (a != q) try {
            var c = this;
            a.call(b, function(a) {
                O(c, 2, a)
            }, function(a) {
                O(c, 3, a)
            })
        } catch (d) {
            O(this, 3, d)
        }
    }

    function Ub() {
        this.next = this.i = this.g = this.j = this.b = null;
        this.o = !1
    }
    Ub.prototype.reset = function() {
        this.i = this.g = this.j = this.b = null;
        this.o = !1
    };
    var Vb = new pa(function() {
        return new Ub
    }, function(a) {
        a.reset()
    }, 100);

    function Wb(a, b, c) {
        var d = Vb.get();
        d.j = a;
        d.g = b;
        d.i = c;
        return d
    }
    N.prototype.then = function(a, b, c) {
        return Xb(this, u(a) ? a : null, u(b) ? b : null, c)
    };
    za(N);
    N.prototype.cancel = function(a) {
        0 == this.b && Bb(function() {
            var b = new P(a);
            Yb(this, b)
        }, this)
    };

    function Yb(a, b) {
        if (0 == a.b)
            if (a.i) {
                var c = a.i;
                if (c.g) {
                    for (var d = 0, e = null, f = null, g = c.g; g && (g.o || (d++, g.b == a && (e = g), !(e && 1 < d))); g = g.next) e || (f = g);
                    e && (0 == c.b && 1 == d ? Yb(c, b) : (f ? (d = f, d.next == c.j && (c.j = d), d.next = d.next.next) : Zb(c), $b(c, e, 3, b)))
                }
                a.i = null
            } else O(a, 3, b)
    }

    function ac(a, b) {
        a.g || 2 != a.b && 3 != a.b || bc(a);
        a.j ? a.j.next = b : a.g = b;
        a.j = b
    }

    function Xb(a, b, c, d) {
        var e = Wb(null, null, null);
        e.b = new N(function(a, g) {
            e.j = b ? function(c) {
                try {
                    var e = b.call(d, c);
                    a(e)
                } catch (w) {
                    g(w)
                }
            } : a;
            e.g = c ? function(b) {
                try {
                    var e = c.call(d, b);
                    !p(e) && b instanceof P ? g(b) : a(e)
                } catch (w) {
                    g(w)
                }
            } : g
        });
        e.b.i = a;
        ac(a, e);
        return e.b
    }
    N.prototype.H = function(a) {
        this.b = 0;
        O(this, 2, a)
    };
    N.prototype.R = function(a) {
        this.b = 0;
        O(this, 3, a)
    };

    function O(a, b, c) {
        if (0 == a.b) {
            a === c && (b = 3, c = new TypeError("Promise cannot resolve to itself"));
            a.b = 1;
            var d;
            a: {
                var e = c,
                    f = a.H,
                    g = a.R;
                if (e instanceof N) ac(e, Wb(f || q, g || null, a)),
                d = !0;
                else if (Aa(e)) e.then(f, g, a),
                d = !0;
                else {
                    if (ka(e)) try {
                        var h = e.then;
                        if (u(h)) {
                            cc(e, h, f, g, a);
                            d = !0;
                            break a
                        }
                    } catch (m) {
                        g.call(a, m);
                        d = !0;
                        break a
                    }
                    d = !1
                }
            }
            d || (a.u = c, a.b = b, a.i = null, bc(a), 3 != b || c instanceof P || dc(a, c))
        }
    }

    function cc(a, b, c, d, e) {
        function f(a) {
            h || (h = !0, d.call(e, a))
        }

        function g(a) {
            h || (h = !0, c.call(e, a))
        }
        var h = !1;
        try {
            b.call(a, g, f)
        } catch (m) {
            f(m)
        }
    }

    function bc(a) {
        a.s || (a.s = !0, Bb(a.v, a))
    }

    function Zb(a) {
        var b = null;
        a.g && (b = a.g, a.g = b.next, b.next = null);
        a.g || (a.j = null);
        return b
    }
    N.prototype.v = function() {
        for (var a; a = Zb(this);) $b(this, a, this.b, this.u);
        this.s = !1
    };

    function $b(a, b, c, d) {
        if (3 == c && b.g && !b.o)
            for (; a && a.o; a = a.i) a.o = !1;
        if (b.b) b.b.i = null, ec(b, c, d);
        else try {
            b.o ? b.j.call(b.i) : ec(b, c, d)
        } catch (e) {
            fc.call(null, e)
        }
        qa(Vb, b)
    }

    function ec(a, b, c) {
        2 == b ? a.j.call(a.i, c) : a.g && a.g.call(a.i, c)
    }

    function dc(a, b) {
        a.o = !0;
        Bb(function() {
            a.o && fc.call(null, b)
        })
    }
    var fc = mb;

    function P(a) {
        z.call(this, a)
    }
    y(P, z);
    P.prototype.name = "cancel";

    function Q(a, b) {
        this.g = this.v = this.j = "";
        this.u = null;
        this.o = this.s = "";
        this.i = !1;
        var c;
        if (a instanceof Q) {
            this.i = p(b) ? b : a.i;
            gc(this, a.j);
            this.v = a.v;
            this.g = a.g;
            hc(this, a.u);
            this.s = a.s;
            c = a.b;
            var d = new R;
            d.i = c.i;
            c.b && (d.b = new Kb(c.b), d.g = c.g);
            ic(this, d);
            this.o = a.o
        } else a && (c = String(a).match(eb)) ? (this.i = !!b, gc(this, c[1] || "", !0), this.v = S(c[2] || ""), this.g = S(c[3] || "", !0), hc(this, c[4]), this.s = S(c[5] || "", !0), ic(this, c[6] || "", !0), this.o = S(c[7] || "")) : (this.i = !!b, this.b = new R(null, 0, this.i))
    }
    Q.prototype.toString = function() {
        var a = [],
            b = this.j;
        b && a.push(T(b, jc, !0), ":");
        var c = this.g;
        if (c || "file" == b) a.push("//"), (b = this.v) && a.push(T(b, jc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.u, null != c && a.push(":", String(c));
        if (c = this.s) this.g && "/" != c.charAt(0) && a.push("/"), a.push(T(c, "/" == c.charAt(0) ? kc : lc, !0));
        (c = this.b.toString()) && a.push("?", c);
        (c = this.o) && a.push("#", T(c, mc));
        return a.join("")
    };

    function gc(a, b, c) {
        a.j = c ? S(b, !0) : b;
        a.j && (a.j = a.j.replace(/:$/, ""))
    }

    function hc(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
            a.u = b
        } else a.u = null
    }

    function ic(a, b, c) {
        b instanceof R ? (a.b = b, nc(a.b, a.i)) : (c || (b = T(b, oc)), a.b = new R(b, 0, a.i))
    }

    function S(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : ""
    }

    function T(a, b, c) {
        return t(a) ? (a = encodeURI(a).replace(b, pc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null
    }

    function pc(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16)
    }
    var jc = /[#\/\?@]/g,
        lc = /[\#\?:]/g,
        kc = /[\#\?]/g,
        oc = /[\#\?@]/g,
        mc = /#/g;

    function R(a, b, c) {
        this.g = this.b = null;
        this.i = a || null;
        this.j = !!c
    }

    function U(a) {
        a.b || (a.b = new Kb, a.g = 0, a.i && fb(a.i, function(b, c) {
            var d = decodeURIComponent(b.replace(/\+/g, " "));
            U(a);
            a.i = null;
            var d = V(a, d),
                e = a.b.get(d);
            e || a.b.set(d, e = []);
            e.push(c);
            a.g += 1
        }))
    }
    k = R.prototype;
    k.remove = function(a) {
        U(this);
        a = V(this, a);
        return K(this.b.g, a) ? (this.i = null, this.g -= this.b.get(a).length, this.b.remove(a)) : !1
    };
    k.clear = function() {
        this.b = this.i = null;
        this.g = 0
    };

    function qc(a, b) {
        U(a);
        b = V(a, b);
        return K(a.b.g, b)
    }
    k.U = function() {
        U(this);
        for (var a = this.b.S(), b = this.b.U(), c = [], d = 0; d < b.length; d++)
            for (var e = a[d], f = 0; f < e.length; f++) c.push(b[d]);
        return c
    };
    k.S = function(a) {
        U(this);
        var b = [];
        if (t(a)) qc(this, a) && (b = Ya(b, this.b.get(V(this, a))));
        else {
            a = this.b.S();
            for (var c = 0; c < a.length; c++) b = Ya(b, a[c])
        }
        return b
    };
    k.set = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        qc(this, a) && (this.g -= this.b.get(a).length);
        this.b.set(a, [b]);
        this.g += 1;
        return this
    };
    k.get = function(a, b) {
        var c = a ? this.S(a) : [];
        return 0 < c.length ? String(c[0]) : b
    };

    function rc(a, b, c) {
        a.remove(b);
        0 < c.length && (a.i = null, a.b.set(V(a, b), Za(c)), a.g += c.length)
    }
    k.toString = function() {
        if (this.i) return this.i;
        if (!this.b) return "";
        for (var a = [], b = this.b.U(), c = 0; c < b.length; c++)
            for (var d = b[c], e = encodeURIComponent(String(d)), d = this.S(d), f = 0; f < d.length; f++) {
                var g = e;
                "" !== d[f] && (g += "=" + encodeURIComponent(String(d[f])));
                a.push(g)
            }
        return this.i = a.join("&")
    };

    function V(a, b) {
        var c = String(b);
        a.j && (c = c.toLowerCase());
        return c
    }

    function nc(a, b) {
        b && !a.j && (U(a), a.i = null, a.b.forEach(function(a, b) {
            var c = b.toLowerCase();
            b != c && (this.remove(b), rc(this, c, a))
        }, a));
        a.j = b
    };
    var sc = "closure_lm_" + (1E6 * Math.random() | 0),
        tc = {},
        uc = 0;

    function vc(a, b, c, d, e) {
        if (r(b))
            for (var f = 0; f < b.length; f++) vc(a, b[f], c, d, e);
        else c = wc(c), a && a[B] ? hb(a.b, String(b), c, !1, d, e) : xc(a, b, c, !1, d, e)
    }

    function xc(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        var g = !!e,
            h = yc(a);
        h || (a[sc] = h = new gb(a));
        c = hb(h, b, c, d, e, f);
        if (!c.b) {
            d = zc();
            c.b = d;
            d.src = a;
            d.listener = c;
            if (a.addEventListener) a.addEventListener(b.toString(), d, g);
            else if (a.attachEvent) a.attachEvent(Ac(b.toString()), d);
            else throw Error("addEventListener and attachEvent are unavailable.");
            uc++
        }
    }

    function zc() {
        var a = Bc,
            b = Ib ? function(c) {
                return a.call(b.src, b.listener, c)
            } : function(c) {
                c = a.call(b.src, b.listener, c);
                if (!c) return c
            };
        return b
    }

    function Cc(a, b, c, d, e) {
        if (r(b))
            for (var f = 0; f < b.length; f++) Cc(a, b[f], c, d, e);
        else c = wc(c), a && a[B] ? hb(a.b, String(b), c, !0, d, e) : xc(a, b, c, !0, d, e)
    }

    function Dc(a, b, c, d, e) {
        if (r(b))
            for (var f = 0; f < b.length; f++) Dc(a, b[f], c, d, e);
        else(c = wc(c), a && a[B]) ? a.b.remove(String(b), c, d, e) : a && (a = yc(a)) && (b = a.b[b.toString()], a = -1, b && (a = ib(b, c, !!d, e)), (c = -1 < a ? b[a] : null) && Ec(c))
    }

    function Ec(a) {
        if ("number" != typeof a && a && !a.T) {
            var b = a.src;
            if (b && b[B]) jb(b.b, a);
            else {
                var c = a.type,
                    d = a.b;
                b.removeEventListener ? b.removeEventListener(c, d, a.$) : b.detachEvent && b.detachEvent(Ac(c), d);
                uc--;
                (c = yc(b)) ? (jb(c, a), 0 == c.g && (c.src = null, b[sc] = null)) : db(a)
            }
        }
    }

    function Ac(a) {
        return a in tc ? tc[a] : tc[a] = "on" + a
    }

    function Fc(a, b, c, d) {
        var e = !0;
        if (a = yc(a))
            if (b = a.b[b.toString()])
                for (b = b.concat(), a = 0; a < b.length; a++) {
                    var f = b[a];
                    f && f.$ == c && !f.T && (f = Gc(f, d), e = e && !1 !== f)
                }
            return e
    }

    function Gc(a, b) {
        var c = a.listener,
            d = a.ha || a.src;
        a.W && Ec(a);
        return c.call(d, b)
    }

    function Bc(a, b) {
        if (a.T) return !0;
        if (!Ib) {
            var c;
            if (!(c = b)) a: {
                c = ["window", "event"];
                for (var d = n, e; e = c.shift();)
                    if (null != d[e]) d = d[e];
                    else {
                        c = null;
                        break a
                    }
                c = d
            }
            e = c;
            c = new M(e, this);
            d = !0;
            if (!(0 > e.keyCode || void 0 != e.returnValue)) {
                a: {
                    var f = !1;
                    if (0 == e.keyCode) try {
                        e.keyCode = -1;
                        break a
                    } catch (m) {
                        f = !0
                    }
                    if (f || void 0 == e.returnValue) e.returnValue = !0
                }
                e = [];
                for (f = c.b; f; f = f.parentNode) e.push(f);
                for (var f = a.type, g = e.length - 1; 0 <= g; g--) {
                    c.b = e[g];
                    var h = Fc(e[g], f, !0, c),
                        d = d && h
                }
                for (g = 0; g < e.length; g++) c.b = e[g],
                h = Fc(e[g], f, !1, c),
                d = d && h
            }
            return d
        }
        return Gc(a, new M(b, this))
    }

    function yc(a) {
        a = a[sc];
        return a instanceof gb ? a : null
    }
    var Hc = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);

    function wc(a) {
        if (u(a)) return a;
        a[Hc] || (a[Hc] = function(b) {
            return a.handleEvent(b)
        });
        return a[Hc]
    };

    function W(a, b, c) {
        if (t(b))(b = Ic(a, b)) && (a.style[b] = c);
        else
            for (var d in b) {
                c = a;
                var e = b[d],
                    f = Ic(c, d);
                f && (c.style[f] = e)
            }
    }
    var Jc = {};

    function Ic(a, b) {
        var c = Jc[b];
        if (!c) {
            var d = Pa(b),
                c = d;
            void 0 === a.style[d] && (d = (I ? "Webkit" : H ? "Moz" : G ? "ms" : rb ? "O" : null) + Qa(d), void 0 !== a.style[d] && (c = d));
            Jc[b] = c
        }
        return c
    }

    function Kc(a, b, c) {
        var d;
        b instanceof F ? (d = b.g, b = b.b) : (d = b, b = c);
        a.style.left = Lc(d, !1);
        a.style.top = Lc(b, !1)
    }

    function Mc(a, b, c) {
        if (b instanceof A) c = b.height, b = b.width;
        else if (void 0 == c) throw Error("missing height argument");
        a.style.width = Lc(b, !0);
        a.style.height = Lc(c, !0)
    }

    function Lc(a, b) {
        "number" == typeof a && (a = (b ? Math.round(a) : a) + "px");
        return a
    }

    function Nc(a, b) {
        var c = a.style;
        "opacity" in c ? c.opacity = b : "MozOpacity" in c ? c.MozOpacity = b : "filter" in c && (c.filter = "" === b ? "" : "alpha(opacity=" + 100 * Number(b) + ")")
    };
    /*
     Portions of this code are from MochiKit, received by
     The Closure Authors under the MIT license. All other code is Copyright
     2005-2009 The Closure Authors. All Rights Reserved.
    */
    function X(a, b) {
        this.o = [];
        this.ma = a;
        this.V = b || null;
        this.j = this.b = !1;
        this.i = void 0;
        this.H = this.ua = this.u = !1;
        this.s = 0;
        this.g = null;
        this.v = 0
    }
    X.prototype.cancel = function(a) {
        if (this.b) this.i instanceof X && this.i.cancel();
        else {
            if (this.g) {
                var b = this.g;
                delete this.g;
                a ? b.cancel(a) : (b.v--, 0 >= b.v && b.cancel())
            }
            this.ma ? this.ma.call(this.V, this) : this.H = !0;
            this.b || (a = new Y, Oc(this), Pc(this, !1, a))
        }
    };
    X.prototype.R = function(a, b) {
        this.u = !1;
        Pc(this, a, b)
    };

    function Pc(a, b, c) {
        a.b = !0;
        a.i = c;
        a.j = !b;
        Qc(a)
    }

    function Oc(a) {
        if (a.b) {
            if (!a.H) throw new Rc;
            a.H = !1
        }
    }
    X.prototype.callback = function(a) {
        Oc(this);
        Pc(this, !0, a)
    };

    function Sc(a, b, c, d) {
        a.o.push([b, c, d]);
        a.b && Qc(a)
    }
    X.prototype.then = function(a, b, c) {
        var d, e, f = new N(function(a, b) {
            d = a;
            e = b
        });
        Sc(this, d, function(a) {
            a instanceof Y ? f.cancel() : e(a)
        });
        return f.then(a, b, c)
    };
    za(X);

    function Tc(a) {
        return Xa(a.o, function(a) {
            return u(a[1])
        })
    }

    function Qc(a) {
        if (a.s && a.b && Tc(a)) {
            var b = a.s,
                c = Uc[b];
            c && (n.clearTimeout(c.w), delete Uc[b]);
            a.s = 0
        }
        a.g && (a.g.v--, delete a.g);
        for (var b = a.i, d = c = !1; a.o.length && !a.u;) {
            var e = a.o.shift(),
                f = e[0],
                g = e[1],
                e = e[2];
            if (f = a.j ? g : f) try {
                var h = f.call(e || a.V, b);
                p(h) && (a.j = a.j && (h == b || h instanceof Error), a.i = b = h);
                if (Aa(b) || "function" === typeof n.Promise && b instanceof n.Promise) d = !0, a.u = !0
            } catch (m) {
                b = m, a.j = !0, Tc(a) || (c = !0)
            }
        }
        a.i = b;
        d && (h = v(a.R, a, !0), d = v(a.R, a, !1), b instanceof X ? (Sc(b, h, d), b.ua = !0) : b.then(h, d));
        c && (b = new Vc(b),
            Uc[b.w] = b, a.s = b.w)
    }

    function Rc() {
        z.call(this)
    }
    y(Rc, z);
    Rc.prototype.message = "Deferred has already fired";
    Rc.prototype.name = "AlreadyCalledError";

    function Y() {
        z.call(this)
    }
    y(Y, z);
    Y.prototype.message = "Deferred was canceled";
    Y.prototype.name = "CanceledError";

    function Vc(a) {
        this.w = n.setTimeout(v(this.g, this), 0);
        this.b = a
    }
    Vc.prototype.g = function() {
        delete Uc[this.w];
        throw this.b;
    };
    var Uc = {};

    function Wc() {
        Ra.call(this);
        this.b = new gb(this);
        this.u = this
    }
    y(Wc, Ra);
    Wc.prototype[B] = !0;
    Wc.prototype.removeEventListener = function(a, b, c, d) {
        Dc(this, a, b, c, d)
    };

    function Xc(a, b) {
        var c = a.u,
            d = b,
            e = d.type || d;
        if (t(d)) d = new E(d, c);
        else if (d instanceof E) d.g = d.g || c;
        else {
            var f = d,
                d = new E(e, c);
            ya(d, f)
        }
        c = d.b = c;
        Yc(c, e, !0, d);
        Yc(c, e, !1, d)
    }

    function Yc(a, b, c, d) {
        if (b = a.b.b[String(b)]) {
            b = b.concat();
            for (var e = !0, f = 0; f < b.length; ++f) {
                var g = b[f];
                if (g && !g.T && g.$ == c) {
                    var h = g.listener,
                        m = g.ha || g.src;
                    g.W && jb(a.b, g);
                    e = !1 !== h.call(m, d) && e
                }
            }
        }
    };

    function Zc(a, b) {
        var c = b || {},
            d = c.document || document,
            e;
        a instanceof kb && a.constructor === kb && a.g === lb ? e = a.b : (ia(a), e = "type_error:TrustedResourceUrl");
        var f = L("SCRIPT"),
            g = {
                ra: f,
                ka: void 0
            },
            h = new X($c, g),
            m = null,
            w = null != c.timeout ? c.timeout : 5E3;
        0 < w && (m = window.setTimeout(function() {
            ad(f, !0);
            var a = new bd(1, "Timeout reached for loading script " + e);
            Oc(h);
            Pc(h, !1, a)
        }, w), g.ka = m);
        f.onload = f.onreadystatechange = function() {
            f.readyState && "loaded" != f.readyState && "complete" != f.readyState || (ad(f, c.wa || !1, m), h.callback(null))
        };
        f.onerror = function() {
            ad(f, !0, m);
            var a = new bd(0, "Error while loading script " + e);
            Oc(h);
            Pc(h, !1, a)
        };
        g = c.attributes || {};
        ya(g, {
            type: "text/javascript",
            charset: "UTF-8",
            src: e
        });
        Mb(f, g);
        cd(d).appendChild(f);
        return h
    }

    function cd(a) {
        var b;
        return (b = (a || document).getElementsByTagName("HEAD")) && 0 != b.length ? b[0] : a.documentElement
    }

    function $c() {
        if (this && this.ra) {
            var a = this.ra;
            a && "SCRIPT" == a.tagName && ad(a, !0, this.ka)
        }
    }

    function ad(a, b, c) {
        null != c && n.clearTimeout(c);
        a.onload = q;
        a.onerror = q;
        a.onreadystatechange = q;
        b && window.setTimeout(function() {
            Tb(a)
        }, 0)
    }

    function bd(a, b) {
        var c = "Jsloader error (code #" + a + ")";
        b && (c += ": " + b);
        z.call(this, c)
    }
    y(bd, z);

    function dd(a, b) {
        this.b = b || "en"
    }

    function ed(a) {
        var b = L("img");
        b.src = Ea("https://books.google.com/intl/%s/googlebooks/images/gbs_preview_button1.gif", a.b);
        b.border = "0";
        W(b, "cursor", "pointer");
        return b
    }

    function fd(a, b, c) {
        this.b = c || "en";
        c = L("a");
        c.href = b;
        a.appendChild(c);
        a = ed(this);
        c.appendChild(a)
    }
    y(fd, dd);

    function gd(a, b, c) {
        this.b = c || "en";
        c = ed(this);
        a.appendChild(c);
        W(a, "cursor", "pointer");
        vc(a, "click", b)
    }
    y(gd, dd);

    function hd(a, b) {
        var c = document.getElementsByTagName("body")[0],
            d = L("div");
        Nc(d, .5);
        W(d, {
            backgroundColor: "#333",
            position: "absolute",
            zIndex: 200
        });
        this.o = d;
        Mc(d, c.scrollWidth, Math.max(c.scrollHeight, Ob().height));
        Kc(d, 0, 0);
        c.appendChild(d);
        this.i = L("div");
        W(this.i, {
            position: "absolute",
            zIndex: 201
        });
        c.appendChild(this.i);
        this.g = L("div");
        Mc(this.g, 618, 500);
        W(this.g, {
            backgroundColor: "#333",
            position: "absolute",
            zIndex: 202
        });
        Kc(this.g, 3, 3);
        Nc(this.g, .3);
        this.i.appendChild(this.g);
        this.b = L("div");
        Kc(this.b,
            0, 0);
        W(this.b, {
            position: "absolute",
            padding: "8px",
            border: "1px solid #2c4462",
            backgroundColor: "#b4cffe",
            zIndex: 203
        });
        c = L("div");
        W(c, {
            backgroundColor: "#d8e8fd",
            fontSize: "16px",
            fontFamily: "Arial, sans-serif",
            fontWeight: "bold",
            padding: "2px 2px 2px 5px"
        });
        this.b.appendChild(c);
        d = L("img");
        d.src = "https://books.google.com/googlebooks/images/dialog_close_x.gif";
        d.width = 15;
        d.height = 15;
        W(d, {
            cursor: "pointer",
            position: "absolute",
            right: "11px",
            top: "11px"
        });
        Cc(d, "click", v(this.close, this));
        c.appendChild(d);
        d = L("div");
        d.innerHTML = "&nbsp;";
        c.appendChild(d);
        this.j = L("div");
        this.b.appendChild(this.j);
        Mc(this.j, 750, 456);
        this.i.appendChild(this.b);
        b(this.j, a);
        d = Ob();
        c = Math.max(0, (d.height - 500) / 2);
        c = Math.floor(c + Pb().b);
        d = Math.max(0, (d.width - 618) / 2);
        d = Math.floor(d);
        Kc(this.i, d, c)
    }
    hd.prototype.close = function() {
        Wa([this.b, this.o, this.g], Tb)
    };

    function id(a, b) {
        this.g = new Q(a);
        this.b = b ? b : "callback";
        this.ka = 5E3
    }
    var jd = 0;
    id.prototype.send = function(a, b, c, d) {
        a = a || null;
        d = d || "_" + (jd++).toString(36) + oa().toString(36);
        var e = "_callbacks___" + d,
            f = new Q(this.g);
        if (a)
            for (var g in a)
                if (!a.hasOwnProperty || a.hasOwnProperty(g)) {
                    var h = f,
                        m = g,
                        w = a[g];
                    r(w) || (w = [String(w)]);
                    rc(h.b, m, w)
                }
        b && (n[e] = kd(d, b), b = this.b, g = e, r(g) || (g = [String(g)]), rc(f.b, b, g));
        b = {
            timeout: this.ka,
            wa: !0
        };
        g = new kb;
        g.b = f.toString();
        f = Zc(g, b);
        Sc(f, null, ld(d, a, c), void 0);
        return {
            w: d,
            qa: f
        }
    };
    id.prototype.cancel = function(a) {
        a && (a.qa && a.qa.cancel(), a.w && md(a.w, !1))
    };

    function ld(a, b, c) {
        return function() {
            md(a, !1);
            c && c(b)
        }
    }

    function kd(a, b) {
        return function(c) {
            md(a, !0);
            b.apply(void 0, arguments)
        }
    }

    function md(a, b) {
        var c = "_callbacks___" + a;
        if (n[c])
            if (b) try {
                delete n[c]
            } catch (d) {
                n[c] = void 0
            } else n[c] = q
    };

    function nd() {
        Wc.call(this);
        this.s = null;
        this.o = !0
    }
    y(nd, Wc);
    nd.prototype.i = function() {
        if (this.o) this.o = !1;
        else throw Error();
    };
    nd.prototype.abort = function() {
        throw Error("unimplemented abstract method");
    };

    function Z(a) {
        nd.call(this);
        this.R = new id(a);
        this.g = !0
    }
    y(Z, nd);
    Z.prototype.i = function(a, b) {
        Z.ta.i.call(this, a, b);
        this.g = !1;
        this.R.send({}, v(this.H, this, a), v(this.v, this, b))
    };
    Z.prototype.H = function(a, b) {
        this.g || (this.s = b, Xc(this, "success"), a && a(this.s), this.g = !0)
    };
    Z.prototype.v = function(a) {
        this.g || (Xc(this, "error"), a && a(), this.g = !0)
    };
    Z.prototype.abort = function() {
        return this.g = !0
    };

    function od(a, b, c, d, e) {
        r(a) || (a = [a]);
        this.b = a;
        this.i = b;
        this.g = c;
        b = new Q((GBS_HOST || "https://books.google.com/") + "books?jscmd=viewapi");
        b.b.set("bibkeys", a.join(","));
        b.b.set("hl", e || "en");
        b.b.set("source", d || "previewlib");
        (new Z(b)).i(v(this.j, this))
    }
    od.prototype.j = function(a) {
        for (var b = 0; b < this.b.length; b++) {
            var c = a[this.b[b]];
            if (c) {
                var d = c.preview_url,
                    e;
                if (e = d) e = c.preview, c = c.embeddable, p(c) || (c = !0), e = ("full" == e || "partial" == e) && c;
                if (e) {
                    this.i && this.i(d);
                    return
                }
            }
        }
        this.g && this.g()
    };
    x("GBS_insertPreviewButtonLink", function(a, b) {
        pd(a, na(qd, (b || {}).alternativeUrl), "GBS_insertPreviewButtonLink")
    });
    x("GBS_insertPreviewButtonPopup", function(a) {
        pd(a, rd, "GBS_insertPreviewButtonPopup")
    });
    x("GBS_insertEmbeddedViewer", function(a, b, c) {
        pd(a, na(sd, b, c), "GBS_insertEmbeddedViewer")
    });

    function pd(a, b, c) {
        var d = td();
        new od(a, function(a) {
            b(d, a)
        }, null, c, ud)
    }

    function qd(a, b, c) {
        a || (a = new Q(c), vd && (c = new Q(GBS_HOST), gc(a, c.j), a.g = c.g, hc(a, c.u), a.s = "/books/p/" + vd), a = a.toString().replace(/#.*/g, ""), a = new Q(a), a.b.set("hl", "en"), a = a.toString());
        new fd(b, a, ud)
    }

    function rd(a, b) {
        new gd(a, na(wd, b), ud)
    }

    function sd(a, b, c, d) {
        var e = L("div");
        c.appendChild(e);
        Mc(e, a, b);
        xd(e, d)
    }

    function xd(a, b) {
        var c = Qb("IFRAME", {
            frameBorder: "0",
            width: "100%",
            height: "100%"
        });
        a.appendChild(c);
        var d = new Q(b);
        d.b.set("output", "embed");
        if (yd) {
            var e = [];
            sa(new ra, yd, e);
            d.o = encodeURIComponent(String(e.join("")))
        }
        c.src = d.toString()
    }

    function wd(a) {
        new hd(a, xd)
    }
    var ud = "en";
    x("GBS_setLanguage", function(a) {
        ud = a
    });
    x("GBS_setViewerOptions", function(a) {
        yd = a
    });
    var vd = null;
    x("GBS_setCobrandName", function(a) {
        vd = a
    });
    var yd = {};

    function td() {
        var a = "__GBS_Button" + zd++;
        document.write(Ea('<span id="%s"><i class="fa fa-eye" aria-hidden="true"></i> Look inside this book</span>', a));
        var b = document;
        return t(a) ? b.getElementById(a) : a
    }
    var zd = 0;
})();